var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 37,
    viewBox: "0 0 42 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5997 30.1139C22.5997 30.1139 22.5997 21.3454 22.5997 21.345C22.5431 19.7337 23.61 18.2299 25.7567 18.1623C27.8485 18.1623 28.6855 19.6022 28.6855 21.7133V30.1135H34.4667V21.1096C34.4667 16.2862 31.6148 14.0418 27.8107 14.0418C24.6919 14.0418 23.322 15.6153 22.561 16.6872L22.5997 14.4104H16.8185C16.8937 15.8837 16.8181 30.1139 16.8181 30.1139H22.5997ZM13.6179 23.3041V14.4101H7.8359V30.1135H13.6183C13.6171 28.4647 13.6204 24.9298 13.6179 23.3041ZM10.7281 12.2666C12.7439 12.2666 13.999 11.0607 13.999 9.55396C13.9824 5.91959 7.48978 5.95998 7.49507 9.5536C7.49059 11.072 8.78032 12.2853 10.7281 12.2666Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.5758c4309cff719c522e96b3653e970d.svg";
export { ForwardRef as ReactComponent };